import * as signalR from '@microsoft/signalr'
import { computed, onUnmounted, watchEffect } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import useUserStore from '@/store/user'
import { EventBus } from '@/components/event-bus/event-bus'

export default function useUsuarioTicketsNotifications() {
  const { id, isLoggedIn } = storeToRefs(useUserStore())

  const url = computed(() => ({
    remote: `${process.env.VUE_APP_FLOW?.replace('api/', '') || ''}solicitante-tickets-hub?SolicitanteId=${id.value}`,
    local: `https://localhost:7294/solicitante-tickets-hub?SolicitanteId=${id.value}`,
  }))

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(url.value.local, { transport: signalR.HttpTransportType.WebSockets })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.None)
    .build()

  async function startConnection() {
    try {
      connection.baseUrl = url.value.local
      await connection.start()
    } catch {
      setTimeout(startConnection, 5000)
    }
  }

  async function stopConnection() {
    if (connection.state === signalR.HubConnectionState.Disconnected) return
    await connection.stop()
  }

  async function resetConnection() {
    await stopConnection()
    await startConnection()
  }

  watchEffect(async () => {
    if (isLoggedIn.value) {
      await resetConnection()
    } else {
      await stopConnection()
    }
  })

  onUnmounted(stopConnection)

  async function showNotification(message) {
    let granted = false

    if (Notification.permission === 'granted') {
      granted = true
    } else {
      const permission = await Notification.requestPermission()
      granted = permission === 'granted'
    }

    if (granted) {
      const notification = new Notification(message.title, {
        body: message.body,
        icon: 'https://vikdocumentdb.blob.core.windows.net/utils/logo-vik.png?sv=2021-10-04&st=2023-08-15T01%3A33%3A30Z&se=2033-08-16T01%3A33%3A00Z&sr=b&sp=r&sig=ZryzjVz5WrPBS7AnGx6uB95KsAQk3BgvGJZdYOWLxBY%3D',
        tag: 'ticket',
        lang: 'pt-BR',
        vibrate: true,
      })

      setTimeout(() => { notification.close() }, 10 * 1000)
    }
  }

  connection.on('ReceiveTicket', message => {
    showNotification(JSON.parse(message))
    EventBus.$emit('fetch-tickets')
  })

  connection.on('ReceiveTicketMessage', message => {
    showNotification(JSON.parse(message))
    EventBus.$emit('fetch-ticket-messages')
  })

  connection.on('ReceiveTicketUpdate', message => {
    showNotification(JSON.parse(message))
    EventBus.$emit('fetch-tickets')
    EventBus.$emit('fetch-ticket-messages')
  })
}
